import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const getNetwork = () => localStorage.getItem("gmscan_network") || "mainnet";
export const setNetwork = (n) => localStorage.setItem("gmscan_network", n);

api.interceptors.request.use((config) => {
  config.params = { ...(config.params || {}), network: getNetwork() };
  return config;
});
